export class BatteryDataRes {
  constructor(data = {}) {
    this.deviceCompany = data?.deviceCompany || "";
    this.serialNo = data?.serialNo || "";
    this.siteNo = data?.siteNo || 0;
    this.rtuId = data?.rtuId || "";
    this.deviceNo = data?.deviceNo || 0;
    this.state = data?.state || 0;
    this.systemAuto = data?.systemAuto || 0;
    this.systemManual = data?.systemManual || 0;
    this.chargeOn = data?.chargeOn || 0;
    this.dischargeOn = data?.dischargeOn || 0;
    this.s1SaltNaclLv = data?.s1SaltNaclLv || 0;
    this.b1BaseNaohLv = data?.b1BaseNaohLv || 0;
    this.a1AcidHclLv = data?.a1AcidHclLv || 0;
    this.e1ElecNa2so4Lv = data?.e1ElecNa2so4Lv || 0;
    this.s2SaltNaclLv = data?.s2SaltNaclLv || 0;
    this.b2BaseNaohLv = data?.b2BaseNaohLv || 0;
    this.a2AcidHclLv = data?.a2AcidHclLv || 0;
    this.d1DrainLv = data?.d1DrainLv || 0;
    this.s1SaltNaclPh = data?.s1SaltNaclPh || 0;
    this.b1BaseNaohPh = data?.b1BaseNaohPh || 0;
    this.a1AcidHclPh = data?.a1AcidHclPh || 0;
    this.e1ElecNa2so4Ph = data?.e1ElecNa2so4Ph || 0;
    this.s2SaphNaclPh = data?.s2SaphNaclPh || 0;
    this.b2BaseNaohPh = data?.b2BaseNaohPh || 0;
    this.a2AcidHclPh = data?.a2AcidHclPh || 0;
    this.s1SaltNaclCond = data?.s1SaltNaclCond || 0;
    this.b1BaseNaohCond = data?.b1BaseNaohCond || 0;
    this.a1AcidHclCond = data?.a1AcidHclCond || 0;
    this.e1ElecNa2so4Cond = data?.e1ElecNa2so4Cond || 0;
    this.s2SaltNaclCond = data?.s2SaltNaclCond || 0;
    this.b2BaseNaohCond = data?.b2BaseNaohCond || 0;
    this.a2AcidHclCond = data?.a2AcidHclCond || 0;
    this.s11SaltNaclChargeFlow = data?.s11SaltNaclChargeFlow || 0;
    this.b11BaseNaohChargeFlow = data?.b11BaseNaohChargeFlow || 0;
    this.a11AcidHclChargeFlow = data?.a11AcidHclChargeFlow || 0;
    this.e1ElecNa2so4ChargeFlow = data?.e1ElecNa2so4ChargeFlow || 0;
    this.s21SaftNaclChargeFlow = data?.s21SaftNaclChargeFlow || 0;
    this.b21BaseNaohChargeFlow = data?.b21BaseNaohChargeFlow || 0;
    this.a21AcidHclChargeFlow = data?.a21AcidHclChargeFlow || 0;
    this.s12SaltNaclDischargeFlow = data?.s12SaltNaclDischargeFlow || 0;
    this.b12BaseNaohDischargeFlow = data?.b12BaseNaohDischargeFlow || 0;
    this.a12AcidHclDischargeFlow = data?.a12AcidHclDischargeFlow || 0;
    this.e1ElecNa2so4DischargeFlow = data?.e1ElecNa2so4DischargeFlow || 0;
    this.s22SaftNaclDischargeFlow = data?.s22SaftNaclDischargeFlow || 0;
    this.b22BaseNaohDischargeFlow = data?.b22BaseNaohDischargeFlow || 0;
    this.a22AcidHclDischargeFlow = data?.a22AcidHclDischargeFlow || 0;

    this.s11SaltNaclChargePressure = data?.s11SaltNaclChargePressure || 0;
    this.b11BaseNaohChargePressure = data?.b11BaseNaohChargePressure || 0;
    this.a11AcidHclChargePressure = data?.a11AcidHclChargePressure || 0;
    this.e1ElecNa2so4ChargePressure = data?.e1ElecNa2so4ChargePressure || 0;
    this.s21SaptNaclChargePressure = data?.s21SaptNaclChargePressure || 0;
    this.b21BaseNaohChargePressure = data?.b21BaseNaohChargePressure || 0;
    this.a21AcidHclChargePressure = data?.a21AcidHclChargePressure || 0;
    this.s12SaltNaclDischargePressure = data?.s12SaltNaclDischargePressure || 0;
    this.b12BaseNaohDischargePressure = data?.b12BaseNaohDischargePressure || 0;
    this.a12AcidHclDischargePressure = data?.a12AcidHclDischargePressure || 0;
    this.e1ElecNa2so4DischargePressure = data?.e1ElecNa2so4DischargePressure || 0;
    this.s22SaptNaclDischargePressure = data?.s22SaptNaclDischargePressure || 0;
    this.b22BaseNaohDischargePressure = data?.b22BaseNaohDischargePressure || 0;
    this.a22AcidHclDischargePressure = data?.a22AcidHclDischargePressure || 0;

    this.panelInputValtage = data?.panelInputValtage || 0;
    this.panelInputAmprere = data?.panelInputAmprere || 0;
    this.panelPower = data?.panelPower || 0;
    this.panelWattage = data?.panelWattage || 0;
    this.ed1ChargeVoltage = data?.ed1ChargeVoltage || 0;
    this.ed1ChargeAmprere = data?.ed1ChargeAmprere || 0;
    this.ed1ChargeWattage = data?.ed1ChargeWattage || 0;
    this.ed1ChargeAccPower = data?.ed1ChargeAccPower || 0;
    this.ed2DischargeVoltage = data?.ed2DischargeVoltage || 0;
    this.ed2DischargeAmprere = data?.ed2DischargeAmprere || 0;
    this.ed2DischargeWattage = data?.ed2DischargeWattage || 0;
    this.ed2DischargeAccPower = data?.ed2DischargeAccPower || 0;
    this.time = data?.time || "";
  }

  // 테스트용으로 만든 함수 (추후 제거)
  setTestInfo() {
    this.systemAuto = 1;
    this.systemManual = 0;
    this.chargeOn = 1;
    this.dischargeOn = 0;
  }

  toObject() {
    return { ...this };
  }
}
